__webpack_require__.hmrF = () => ("devextreme." + __webpack_require__.h() + ".hot-update.json");